<template>
    <div class="w-full h-full relative">
        <div class="sticky left-0 w-screen max-h-screen" :style="{ height: mapHeight, top: mapTop }">
            <div v-show="loading"
                class="absolute z-[2] left-4 top-4 md:left-auto md:right-16 bg-white dark:bg-neutral-900 ring-1 !ring-black/10 dark:!ring-neutral-300/10 px-4 py-3 md:px-3 md:py-2 rounded-full flex gap-2 items-center hover:scale-105 transition cursor-pointer text-base md:text-xs">
                <div class="flex gap-2 items-center">
                    <div role="status">
                        <svg aria-hidden="true" class="inline w-4 h-4 text-white animate-spin fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span>{{ $t('Loading') }}</span>
                </div>
            </div>
            <div class="w-screen" :style="{ height: mapHeight }" ref="mapContainer"></div>
        </div>


        <div class="relative -mt-[30vh] md:-mt-0 md:absolute md:left-2 md:top-2 md:p-1 z-[5] w-3xs w-full md:w-[80vw] flex"
            ref="searchbox" :class="iframe ? 'md:!w-[300px]' : ''">
            <div class="flex flex-col sm:flex-row justify-center items-end sm:items-center sm:justify-between max-w-full">
                <div class="w-full items-center pb-4 flex gap-2 text-base md:text-xs overflow-x-scroll py-1 px-4 md:px-1">
                    <div v-for="cat in categories" :key="cat.value" @click="selectCategory(cat.value)"
                        class="bg-white dark:bg-neutral-900/20 backdrop-blur-xl ring-1 !ring-black/10 dark:!ring-neutral-300/10 px-3 py-2 rounded-full shrink-0 flex gap-2 items-center hover:scale-105 active:scale-90 transition cursor-pointer"
                        :class="isActiveCategory(cat.value) ? '!bg-neutral-900 dark:!bg-white !text-white dark:!text-black' : cat.color">
                        <svg-vue :icon="cat.icon" class="h-4 md:h-3"></svg-vue>
                        <div>{{ $t(cat.label) }}</div>
                    </div>

                </div>
            </div>
        </div>

        <div ref="sidebar"
            class="relative md:-mt-[70vh] z-[2] pb-12 md:pb-4 w-full md:max-w-[40vw] max-w-[700px] min-h-[75vh]">
            <div class="md:ml-4 mb-4 flex gap-4 w-full px-4 md:px-0">
                <div class="relative text-gray-600 relative w-full">
                    <input v-model="filters.search" @focus="searchFocused = true" @blur="onSearchBlur"
                        class="border-0 w-full bg-white dark:bg-neutral-900/20 dark:backdrop-blur-xl ring-1 !ring-black/10 dark:!ring-neutral-300/10 h-12 px-5 pr-16 rounded-full text-sm focus:outline-none"
                        type="search" name="search" placeholder="Search">
                    <button type="submit" class="absolute right-0 top-0 mt-1 mr-2 p-3 hover:bg-gray-100 rounded-full">
                        <svg class="text-gray-600 h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                            viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;"
                            xml:space="preserve" width="512px" height="512px">
                            <path
                                d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                        </svg>
                    </button>
                </div>
                <div @click="getRandomLocation()"
                    class="bg-white dark:bg-neutral-900/20 text-gray-600 dark:text-neutral-400 dark:backdrop-blur-xl ring-1 !ring-black/10 dark:!ring-neutral-300/10 h-12 w-12 shrink-0 rounded-full text-sm focus:outline-none flex items-center justify-center cursor-pointer hover:scale-105 transition active:scale-90">
                    <svg-vue icon='dice' class="w-6 h-6"></svg-vue>
                </div>
            </div>
            <div v-if="searchFocused">
                <!-- Whatever you want to show when typing -->
                <SearchResult :query="filters.search" :locations="allLocations.slice(0, 20)" @select="handleSelect" />
            </div>

            <router-view v-else :client="$attrs.client" :selected="selectedSlug" :promotions="promotions" />
        </div>
    </div>
</template>
  
<script>
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useTypeMeta } from '../../helpers/useTypeMeta'
const { debounce } = require('lodash');
import SearchResult from './searchResult.vue';

export default {
    name: 'Map',
    components: {
        SearchResult,
    },
    props: {
        iframe: {
            type: Boolean,
            default: false,
        },
        locations: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {
            fallBackLocations: [],
            allLocations: [],
            promotions: [],
            map: null,
            loading: false,
            selectedLocation: null,
            searchFocused: false,
            selectedSlug: null,
            forceUpdate: 0,
            filters: {
                search: '',
                date: '',
                location_id: '',
            },
            isDarkMode: false,
            mapHeight: '80vh',
            gottenPages: 0,
            maxPages: 0,
            mapTop: 0,
            categories: [
                { value: 'all', label: 'All', icon: 'show', color: 'text-gray-700 dark:text-neutral-200' },
                { value: 'must_see', label: 'Must see', icon: 'camera', color: 'text-indigo-400 dark:text-indigo-300' },
                { value: 'food_and_drinks', label: 'Food and Drinks', icon: 'food', color: 'text-amber-500 dark:text-amber-400' },
                { value: 'shopping', label: 'Shopping', icon: 'shopping', color: 'text-yellow-500 dark:text-yellow-400' },
                { value: 'amusement', label: 'Amusement', icon: 'amusement', color: 'text-rose-400 dark:text-rose-300' },
                { value: 'park', label: 'Nature', icon: 'tree', color: 'text-green-500 dark:text-green-400' },
                { value: 'activity', label: 'Activity', icon: 'sport', color: 'text-red-500 dark:text-red-400' },
                { value: 'services', label: 'Services', icon: 'info', color: 'text-stone-600 dark:text-neutral-200' },
                { value: 'transportation', label: 'Transportation', icon: 'bus', color: 'text-emerald-500 dark:text-emerald-400' },
                { value: 'parking', label: 'Parking', icon: 'parking', color: 'text-blue-400 dark:text-blue-300' },
            ]
        };
    },

    mounted() {
        this.loading = true;
        this.updateMapHeight();
        this.updateMapTop();
        this.detectDarkMode();

        window.addEventListener("resize", this.updateMapHeight);

        // Optional: listen for changes in the user's system preference
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.detectDarkMode);

        var initialState = {
            lng: 6.564133087784059,
            lat: 53.2187079160419,
            zoom: 14
        };

        var pos = this.$attrs.client.maps_default_position?.split(',');
        var zoom = this.$attrs.client.maps_default_zoom;
        if (pos && zoom) {
            initialState = {
                lat: pos[0],
                lng: pos[1],
                zoom: zoom
            };
        }

        if (this.isDarkMode) {
            var mapUrl = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
        } else {
            var mapUrl = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';
        }

        // Temporary map just to compute projected offset
        const tmpMap = new maplibregl.Map({
            container: document.createElement('div'), // hidden container
            style: mapUrl,
            center: [initialState.lng, initialState.lat],
            zoom: initialState.zoom
        });

        // Compute offset for sidebar
        const sidebarWidth = this.$refs.sidebar?.offsetWidth || 0;

        let offsetX = 0;
        let offsetY = 0;

        // Desktop → offset horizontally (sidebar)
        if (window.innerWidth >= 1024) {
            offsetX = sidebarWidth / 2;       // push map to the right → center moves left
        }
        // Mobile → offset vertically (UI elements)
        else {
            offsetY = window.innerHeight / 6; // push map downward → center moves upward
        }

        // Project initial center to pixel coordinates
        const centerPoint = tmpMap.project([initialState.lng, initialState.lat]);

        // Apply offset (remember: positive Y = move map down)
        const newCenter = tmpMap.unproject([
            centerPoint.x - offsetX,   // subtract to move map right
            centerPoint.y + offsetY    // add to move map DOWN (center goes UP)
        ]);

        // Remove temporary map
        tmpMap.remove();

        this.map = new maplibregl.Map({
            container: this.$refs.mapContainer,
            style: mapUrl,
            center: [newCenter.lng, newCenter.lat],
            zoom: initialState.zoom,
        });


        this.map.on('load', async () => {
            this.map.addControl(new maplibregl.NavigationControl(), 'top-right');

            // Initial empty source
            const initialGeoJSON = {
                type: 'FeatureCollection',
                features: [],
            };

            this.map.addSource('locations', {
                type: 'geojson',
                data: initialGeoJSON,
            });

            const initialGeoJSONPromotions = {
                type: 'FeatureCollection',
                features: [],
            };

            this.map.addSource('promotions', {
                type: 'geojson',
                data: initialGeoJSONPromotions,
            });

            // await this.drawRouteWithOSRM();

            // ...new Set(this.locations.map(loc => loc.icon).filter(Boolean))
            // Get unique icon names from locations
            const iconNames = [
                "must_see",
                "shopping",
                "amusement",
                "food_and_drinks",
                "parking",
                "services",
                "park",
                "health",
                "institution",
                "activity",
                "transportation",
                "must_see_small",
                "shopping_small",
                "amusement_small",
                "food_and_drinks_small",
                "parking_small",
                "services_small",
                "park_small",
                "health_small",
                "institution_small",
                "activity_small",
                "transportation_small",

                "promotion",
                "default",
                "iconDot",
            ];

            await Promise.all(iconNames.map(async name => {
                try {
                    const highResImg = await this.loadSVGAsHighResImage(this.$baseUrl + `/platform/images/icons/map/${name}.svg`);
                    if (!this.map.hasImage(name)) {
                        this.map.addImage(name, highResImg);
                    }
                } catch (error) {
                    console.warn(`Error loading image for icon ${name}`, error);
                }
            }));

            const textColor = this.isDarkMode ? '#c2c2c2' : '#000';
            const textHaloColor = this.isDarkMode ? '#202020' : '#fff';


            this.map.addLayer({
                id: 'locations',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-size': 0.3,
                    'icon-padding': 20,
                    'icon-allow-overlap': false,
                    'icon-image': ['coalesce', ['get', 'type'], 'default'],
                    'text-field': ['get', 'title'],
                    'text-size': 14,
                    'text-variable-anchor': ['left', 'right'],
                    'text-radial-offset': 1.2,
                    'text-justify': 'auto',
                    'text-optional': true,
                    'text-allow-overlap': false,
                },
                paint: {
                    'text-color': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        '#007aff', // Hover color (e.g. blue)
                        textColor    // Default color
                    ],
                    'text-halo-color': textHaloColor,
                    'text-halo-width': 1.5
                }
            });


            const circleColor = getComputedStyle(document.documentElement).getPropertyValue('--main_color').trim();
            const opcColor = getComputedStyle(document.documentElement).getPropertyValue('--main_color_opc').trim();

            this.map.addLayer({
                id: 'promotions',
                type: 'symbol',
                source: 'promotions',
                layout: {
                    'icon-size': 0.5,
                    'icon-allow-overlap': true,
                    'icon-image': ['coalesce', ['get', 'icon_id'], 'promotion'],
                    'text-field': ['get', 'title'],
                    'text-size': 15,
                    'text-variable-anchor': ['left', 'right'],
                    'text-radial-offset': 1.85,
                    'text-justify': 'auto',
                    'text-optional': true,
                    'text-allow-overlap': false,
                    'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold']
                },
                paint: {
                    'text-color': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        '#007aff', // Hover color
                        textColor     // Default color
                    ],
                    'text-halo-color': textHaloColor,
                    'text-halo-width': 1.5
                },
                filter: ['all']
            });

            this.map.addLayer({
                id: 'locations-selected',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-size': 0.4,
                    'icon-image': ['coalesce', ['get', 'type'], 'default'],
                    'icon-anchor': 'bottom',
                    'icon-allow-overlap': true,
                    'text-field': ['get', 'title'],
                    'text-size': 16,
                    'text-anchor': 'left',
                    'text-justify': 'left',
                    'text-offset': [1.5, -1.2],
                    'text-optional': true,
                    'text-allow-overlap': false,
                },
                paint: {
                    'text-color': textColor,
                    'text-halo-color': textHaloColor,
                    'text-halo-width': 1.5
                },
                filter: ['==', 'id', ''] // no selection initially
            });

            this.map.addLayer({
                id: 'locations-selected-circle',
                type: 'circle',
                source: 'locations',
                paint: {
                    'circle-radius': 30,
                    'circle-color': opcColor,
                    'circle-stroke-color': circleColor,
                    'circle-stroke-width': 2,
                    // Optionally add animation by toggling circle-opacity or radius with setInterval
                },
                filter: ['==', 'id', ''] // no selection at start
            }, 'locations-selected');

            this.map.addLayer({
                id: 'dots',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-size': 0.4,
                    'icon-padding': 0.1,
                    'icon-allow-overlap': false,
                    'icon-image': [
                        'coalesce',
                        ['concat', ['get', 'type'], '_small'],
                        'default_small'
                    ]
                },
            }, 'locations');

            // Start loading location data
            await this.loadLocationsToMap();

            this.map.addControl(
                new maplibregl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    trackUserLocation: true
                })
            );

            let hoveredLocationId = null;


            this.map.on('mousemove', 'locations', (e) => {
                if (e.features.length > 0) {
                    const featureId = e.features[0].id;

                    // Remove hover state from previous
                    if (hoveredLocationId !== null && hoveredLocationId !== featureId) {
                        this.map.setFeatureState({ source: 'locations', id: hoveredLocationId }, { hover: false });
                    }

                    // Set new hover state
                    hoveredLocationId = featureId;
                    this.map.setFeatureState({ source: 'locations', id: hoveredLocationId }, { hover: true });
                }
            });

            this.map.on('mouseleave', 'locations', () => {
                if (hoveredLocationId !== null) {
                    this.map.setFeatureState({ source: 'locations', id: hoveredLocationId }, { hover: false });
                }
                hoveredLocationId = null;
            });

            let hoveredPromotionId = null;

            this.map.on('mousemove', 'promotions', (e) => {
                if (e.features.length > 0) {
                    const featureId = e.features[0].id;


                    if (hoveredPromotionId !== null && hoveredPromotionId !== featureId) {
                        this.map.setFeatureState({ source: 'promotions', id: hoveredPromotionId }, { hover: false });
                    }

                    hoveredPromotionId = featureId;
                    this.map.setFeatureState({ source: 'promotions', id: hoveredPromotionId }, { hover: true });
                }
            });

            this.map.on('mouseleave', 'promotions', () => {
                if (hoveredPromotionId !== null) {
                    this.map.setFeatureState({ source: 'promotions', id: hoveredPromotionId }, { hover: false });
                }
                hoveredPromotionId = null;
            });

            this.map.on('click', 'locations', (e) => {
                this.handleFeatureClick(e.features[0]);
            });

            this.map.on('click', 'promotions', (e) => {
                this.handleFeatureClick(e.features[0], true);
            });

            this.map.on('click', (e) => {
                const features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['locations', 'promotions']
                });

                if (!features.length) {
                    this.selectedLocation = null;
                    this.selectedSlug = null;

                    this.map.setFilter('locations-selected', ['==', 'id', '']);
                    this.map.setFilter('locations-selected-circle', ['==', 'id', '']);
                    this.map.setFilter('promotions', ['all']);

                    this.$router.push({
                        name: 'locations.map.index',
                        query: { ...this.$route.query }
                    });
                }
            });

            // Handle pre-selected location from URL
            const selectedId = new URLSearchParams(window.location.search).get('location');

            if (selectedId) {
                const selectedFeature = this.internalLocations.find(loc => loc.id == selectedId);

                if (selectedFeature) {
                    this.selectedLocation = parseInt(selectedId);
                    this.selectedSlug = selectedFeature.slug;

                    this.$nextTick(() => {
                        const coordinates = [selectedFeature.long, selectedFeature.lat];

                        this.map.setFilter('promotions', ['!=', ['get', 'id'], parseInt(selectedId)]);
                        this.map.setFilter('locations-selected', ['==', 'id', parseInt(selectedId)]);
                        this.map.setFilter('locations-selected-circle', ['==', 'id', parseInt(selectedId)]);

                        this.centerMapOnCoordinates(coordinates);

                        if (window.innerWidth < 768) {
                            this.scrollToFocusArea();
                        }

                        this.forceUpdate++;
                    });
                }
            }

            let growing = true;
            let radius = 15;

            const intervalId = setInterval(() => {
                // Check if layer exists
                if (this.map.getLayer('locations-selected-circle')) {
                    radius = growing ? radius + 1 : radius - 1;
                    if (radius >= 20) growing = false;
                    if (radius <= 10) growing = true;

                    this.map.setPaintProperty('locations-selected-circle', 'circle-radius', radius);
                } else {
                    // Layer no longer exists, stop the animation
                    clearInterval(intervalId);
                }
            }, 100);
        });
    },
    computed: {
        selectedLocationData() {
            return this.internalLocations.find(loc => loc.id == this.selectedLocation);
        },
        internalLocations() {
            return this.locations || [];
        }
    },
    methods: {
        onSearchBlur() {
            setTimeout(() => {
                this.searchFocused = false;
            }, 200);
        },
        handleSelect(location) {
            const selectedSlug = location.slug;
            const selectedId = location.id;
            const coordinates = [location.long, location.lat];

            this.selectedLocation = selectedId;
            this.selectedSlug = location.slug;

            this.$router.push({
                name: 'locations.map.show',
                params: { slug: selectedSlug },
                query: { ...this.$route.query }
            });

            this.map.setFilter('locations-selected', ['==', 'id', selectedId]);
            this.map.setFilter('locations-selected-circle', ['==', 'id', selectedId]);

            this.$nextTick(() => {
                this.centerMapOnCoordinates(coordinates);

                if (window.innerWidth < 768) {
                    this.scrollToFocusArea();
                } else {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            });
        },
        getRandomLocation() {
            if (!this.allLocations || this.allLocations.length === 0) return;

            const filteredLocations = this.allLocations.filter(
                loc => loc.slug !== this.selectedSlug
            );

            const pool = filteredLocations.length ? filteredLocations : this.allLocations;

            const random = pool[Math.floor(Math.random() * pool.length)];

            const selectedSlug = random.slug;
            const selectedId = random.id;
            const coordinates = [random.long, random.lat];

            this.selectedLocation = selectedId;
            this.selectedSlug = random.slug;

            this.$router.push({
                name: 'locations.map.show',
                params: { slug: selectedSlug },
                query: { ...this.$route.query }
            });

            this.map.setFilter('locations-selected', ['==', 'id', selectedId]);
            this.map.setFilter('locations-selected-circle', ['==', 'id', selectedId]);

            this.$nextTick(() => {
                this.centerMapOnCoordinates(coordinates);

                if (window.innerWidth < 768) {
                    this.scrollToFocusArea();
                }
            });
        },
        detectDarkMode() {
            this.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        },
        updateMapHeight() {
            if (window.innerWidth < 768) {
                this.mapHeight = '80vh';
                this.$nextTick(() => {
                    if (this.map) this.map.resize();
                });
                return;
            }

            const nav = document.getElementById('navigationbar')?.offsetHeight || 0;

            const total = nav;
            const height = window.innerHeight - total;

            this.mapHeight = `${height}px`;

            // IMPORTANT → trigger MapLibre to recalc viewport
            this.$nextTick(() => {
                if (this.map) this.map.resize();
            });
        },
        updateMapTop() {
            const nav = document.getElementById('navigationbar')?.offsetHeight || 0;

            const total = nav;
            const height = total;

            this.mapTop = `${height}px`;
        },
        isActiveCategory(type) {
            const current = this.$route.query.type;

            // If nothing selected → "all" is active
            if (!current) {
                return type === "all";
            }

            // Normalize to array
            const selected = Array.isArray(current)
                ? current
                : [current];

            // For "all", only active if array is empty
            if (type === "all") {
                return selected.length === 0;
            }

            return selected.includes(type);
        },

        selectCategory(type) {
            let current = this.$route.query.type;

            // Handle "all" → clears all types
            if (type == "all") {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        type: undefined
                    }
                });
                this.filters.type = [];
                this.allLocations = this.fallBackLocations;


                var features = this.allLocations.map(f => ({
                    type: 'Feature',
                    id: f.id,
                    geometry: {
                        type: 'Point',
                        coordinates: [f.long, f.lat],
                    },
                    properties: {
                        id: f.id,
                        uuid: f.uuid,
                        slug: f.slug,
                        title: f.name?.en || `Locatie ${f.id}`,
                        type: f.type,
                        color: f.color || 'red',
                    },
                }));

                // No filters → update immediately
                const source = this.map.getSource('locations');
                if (source) {
                    source.setData({
                        type: 'FeatureCollection',
                        features,
                    });
                }
                return 1;
            }

            // Normalize current → always an array
            let selected = Array.isArray(current)
                ? [...current]
                : current
                    ? [current]
                    : [];


            // Toggle the type
            if (selected.includes(type)) {
                selected = selected.filter(t => t !== type);
            } else {
                selected.push(type);
            }

            // Apply query update
            this.$router.push({
                query: {
                    ...this.$route.query,
                    type: selected.length > 0 ? selected : undefined
                }
            });

            this.filters.type = selected;
            this.searchLocations();
        },
        async drawRouteWithOSRM() {
            // Example route with 10 waypoints
            const points = [
                [13.388860, 52.517037],
                [13.397634, 52.529407],
                [13.428555, 52.523219],
                [13.438792, 52.519243],
                [13.450995, 52.512411],
                [13.452900, 52.506912],
                [13.440971, 52.502907],
                [13.421860, 52.500436],
                [13.400581, 52.503525],
                [13.388000, 52.509000],
            ];

            try {
                // Build OSRM query
                const coordsString = points.map(p => p.join(',')).join(';');
                const url = `https://router.project-osrm.org/route/v1/driving/${coordsString}?overview=full&geometries=geojson`;

                const res = await fetch(url);
                const data = await res.json();
                if (!data.routes || data.routes.length === 0) throw new Error('No route found');
                const route = data.routes[0].geometry;

                // Add source if not present
                if (!this.map.getSource('route')) {
                    this.map.addSource('route', {
                        type: 'geojson',
                        data: route
                    });

                    this.map.addLayer({
                        id: 'route-line',
                        type: 'line',
                        source: 'route',
                        layout: {
                            'line-join': 'round', // round joins at corners
                            'line-cap': 'round'   // round endpoints
                        },
                        paint: {
                            'line-color': '#007aff',
                            'line-width': 5
                        }
                    });
                } else {
                    this.map.getSource('route').setData(route);
                }

                // Add markers for clarity
                points.forEach((p, i) => {
                    new maplibregl.Marker({
                        color: i === 0 ? 'green' : (i === points.length - 1 ? 'red' : 'gray')
                    }).setLngLat(p).addTo(this.map);
                });

                // Fit map bounds to route
                const bounds = new maplibregl.LngLatBounds();
                route.coordinates.forEach(c => bounds.extend(c));
                this.map.fitBounds(bounds, { padding: 50 });
            } catch (err) {
                console.error('Error drawing route:', err);
            }
        },
        handleFeatureClick(feature, isPromotion = false) {
            const selectedSlug = feature.properties.slug;
            const selectedId = feature.properties.id;
            const coordinates = feature.geometry.coordinates;

            this.selectedLocation = selectedId;
            this.selectedSlug = feature.properties.slug;

            this.$router.push({
                name: 'locations.map.show',
                params: { slug: selectedSlug },
                query: { ...this.$route.query }
            });

            this.map.setFilter('locations-selected', ['==', 'id', selectedId]);
            this.map.setFilter('locations-selected-circle', ['==', 'id', selectedId]);

            if (isPromotion) {
                this.map.setFilter('promotions', ['!=', ['get', 'id'], selectedId]);
            } else {
                this.map.setFilter('promotions', ['all']);
            }

            this.$nextTick(() => {
                this.centerMapOnCoordinates(coordinates);

                if (window.innerWidth < 768) {
                    this.scrollToFocusArea();
                }
            });
        },

        centerMapOnCoordinates(coordinates) {
            const sidebar = this.$refs.sidebar?.offsetWidth || 0;

            let offsetX = 0;
            let offsetY = 0;

            if (window.innerWidth >= 1024) {
                offsetX = sidebar / 2;
            } else {
                offsetY = window.innerHeight / 6;
            }

            const targetZoom = Math.max(16, this.map.getZoom());

            this.map.easeTo({
                center: coordinates,
                zoom: targetZoom,
                offset: [offsetX, -offsetY],
                duration: 800,
            });
        },

        scrollToFocusArea() {
            window.scrollTo({
                top: document.createElement('canvas').height / 2,
                behavior: 'smooth'
            });
        },
        async loadSVGAsHighResImage(url, pixelRatio = Math.min(Math.max(window.devicePixelRatio || 1, 1), 2)) {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Failed to load SVG at ${url}`);
            const svgText = await response.text();

            // Parse dimensions from the SVG itself
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
            const svgEl = svgDoc.documentElement;

            let width = parseFloat(svgEl.getAttribute('width'));
            let height = parseFloat(svgEl.getAttribute('height'));

            if (!width || !height) {
                const viewBox = svgEl.getAttribute('viewBox');
                if (viewBox) {
                    const [, , vbWidth, vbHeight] = viewBox.split(/\s+/).map(parseFloat);
                    width = vbWidth;
                    height = vbHeight;
                }
            }

            // Fallback if dimensions are still invalid
            if (!width || !height) {
                width = 64;
                height = 64;
            }

            const img = new Image();
            const svgDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgText);
            img.src = svgDataUrl;

            return new Promise((resolve, reject) => {
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = width * pixelRatio;
                    canvas.height = height * pixelRatio;

                    const ctx = canvas.getContext('2d');
                    ctx.scale(pixelRatio, pixelRatio);
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(blob => {
                        if (!blob) return reject('Failed to create blob');
                        const highResImg = new Image();
                        const url = URL.createObjectURL(blob);
                        highResImg.onload = () => {
                            URL.revokeObjectURL(url);
                            resolve(highResImg);
                        };
                        highResImg.onerror = reject;
                        highResImg.src = url;
                    });
                };
                img.onerror = reject;
            });
        },
        async loadLocationsToMap() {
            this.loadPromotions('location');
            // If locations already loaded
            if (this.internalLocations && this.internalLocations.length > 0) {
                const allFeatures = this.allLocations.map(f => ({
                    type: 'Feature',
                    id: f.id,
                    uuid: f.uuid,
                    geometry: { type: 'Point', coordinates: [f.long, f.lat] },
                    properties: {
                        id: f.id,
                        uuid: f.uuid,
                        slug: f.slug,
                        title: f.name?.en || `Locatie ${f.id}`,
                        type: f.type,
                        color: f.color || 'red',
                    },
                }));

                this.updateMapFeatures(allFeatures);
                return;
            }

            // Otherwise fetch pages one by one asynchronously
            let page = 1;
            let hasMore = true;

            while (hasMore) {
                this.loading = true;
                fetch(`/resources/locations?page=${page}`)
                    .then(res => res.json())
                    .then(result => {
                        const newFeatures = result.data.map(f => ({
                            type: 'Feature',
                            id: f.id,
                            uuid: f.uuid,
                            geometry: { type: 'Point', coordinates: [f.long, f.lat] },
                            properties: {
                                id: f.id,
                                uuid: f.uuid,
                                slug: f.slug,
                                title: f.name?.en || `Locatie ${f.id}`,
                                type: f.type,
                                color: f.color || 'red',
                            },
                        }));

                        this.allLocations.push(...result.data);
                        this.fallBackLocations.push(...result.data);
                        this.updateMapFeatures([...this.map.getSource('locations')._data.features, ...newFeatures]);

                        this.gottenPages = page;
                        page++;
                        hasMore = result.current_page < result.last_page;
                        this.maxPages = result.last_page;

                        // Trigger next page if exists
                        if (hasMore) {
                            this.loadNextPage(page);
                        }
                        else {
                            this.loading = false
                        }
                    })
                    .catch(err => console.error('Error loading locations:', err));

                // Exit loop immediately to avoid blocking
                break;
            }
        },

        // Helper for next pages
        async loadNextPage(page) {
            fetch(`/resources/locations?page=${page}`)
                .then(res => res.json())
                .then(result => {
                    const newFeatures = result.data.map(f => ({
                        type: 'Feature',
                        id: f.id,
                        uuid: f.uuid,
                        geometry: { type: 'Point', coordinates: [f.long, f.lat] },
                        properties: {
                            id: f.id,
                            uuid: f.uuid,
                            slug: f.slug,
                            title: f.name?.en || `Locatie ${f.id}`,
                            type: f.type,
                            color: f.color || 'red',
                        },
                    }));

                    this.allLocations.push(...result.data);
                    this.fallBackLocations.push(...result.data);
                    this.updateMapFeatures([...this.map.getSource('locations')._data.features, ...newFeatures]);

                    if (result.current_page < result.last_page) {
                        this.loadNextPage(page + 1);
                    } else {
                        this.loading = false
                    }
                });
        },


        async loadPromotions(resourceType = null) {
            try {
                let url = '/resources/promotions';
                if (resourceType) {
                    url += `?type=${resourceType}`;
                }

                const response = await fetch(url,
                    {
                        credentials: 'same-origin',
                    });
                const result = await response.json();
                this.promotions = result.data;

                const features = [];

                for (const promotion of result.data) {
                    if (!promotion || !promotion.item_id) continue;

                    let imageId = 'promotion'; // fallback icon ID
                    let imageUrl = null;

                    if (promotion.image_link) {
                        imageId = `promotion-icon-${promotion.resource.id}`;
                        imageUrl = `/resources/promotion-icon?image_url=${encodeURIComponent(promotion.image_link)}`;

                        // Load image only if it hasn't already been added
                        if (!this.map.hasImage(imageId)) {
                            try {
                                const highResImg = await this.loadSVGAsHighResImage(imageUrl);
                                this.map.addImage(imageId, highResImg);
                            } catch (err) {
                                console.warn(`Failed to load SVG image for promotion ${promotion.id}`, err);
                            }
                        }
                    }

                    features.push({
                        type: 'Feature',
                        id: promotion.resource.id,
                        uuid: promotion.resource.uuid,
                        geometry: {
                            type: 'Point',
                            coordinates: [promotion.resource.long, promotion.resource.lat],
                        },
                        properties: {
                            id: promotion.resource.id,
                            uuid: promotion.resource.uuid,
                            slug: promotion.resource.slug,
                            title: promotion.resource.name?.en || `Locatie ${promotion.resource.id}`,
                            icon_id: imageId,
                            type: promotion.resource?.type,
                            promotionOrder: promotion.order,
                            promotionCosts: promotion.promotion_costs,
                        },
                    });
                }

                const source = this.map.getSource('promotions');
                if (source) {
                    source.setData({
                        type: 'FeatureCollection',
                        features,
                    });
                }

            } catch (error) {
                console.error('Error loading promotions:', error);
            }
        },

        searchLocations: _.debounce(function () {
            this.loading = true;
            const hasFilters = Object.values(this.filters).some(val => val);

            let features = [];

            if (!hasFilters) {
                this.map.setFilter('promotions', ['all']);
                this.allLocations = [...this.fallBackLocations];

                features = this.allLocations.map(f => ({
                    type: 'Feature',
                    id: f.id,
                    geometry: {
                        type: 'Point',
                        coordinates: [f.long, f.lat],
                    },
                    properties: {
                        id: f.id,
                        uuid: f.uuid,
                        slug: f.slug,
                        title: f.name?.en || `Locatie ${f.id}`,
                        type: f.type,
                        color: f.color || 'red',
                    },
                }));
            } else {
                this.map.setFilter('promotions', ['==', 'id', '']);

                const params = new URLSearchParams();
                Object.entries(this.filters).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach(v => params.append(`${key}[]`, v));
                    } else if (value !== undefined && value !== null && value !== "") {
                        params.append(key, value);
                    }
                });

                const baseUrl = `/resources/locations?${params.toString()}`;

                this.fetchPaginated(baseUrl).then(allData => {
                    this.allLocations = allData;

                    const features = allData.map(f => ({
                        type: 'Feature',
                        id: f.id,
                        geometry: {
                            type: 'Point',
                            coordinates: [f.long, f.lat],
                        },
                        properties: {
                            id: f.id,
                            uuid: f.uuid,
                            slug: f.slug,
                            title: f.name?.en || `Locatie ${f.id}`,
                            type: f.type,
                            color: f.color || 'red',
                        },
                    }));

                    const source = this.map.getSource('locations');
                    if (source) {
                        source.setData({
                            type: 'FeatureCollection',
                            features,
                        });
                    }
                });

                this.loading = false;
                return;
            }

            const source = this.map.getSource('locations');
            if (source) {
                source.setData({
                    type: 'FeatureCollection',
                    features,
                });
            }
            this.loading = false;
        }, 300),

        async fetchPaginated(url) {
            const all = [];

            // Use URL API — avoids issues with &page= vs ?page=
            const urlObj = new URL(url, window.location.origin);

            let page = 1;

            while (true) {
                urlObj.searchParams.set("page", page);

                const res = await fetch(urlObj.toString(), {
                    credentials: 'same-origin',
                });
                const json = await res.json();

                all.push(...json.data);

                if (json.current_page >= json.last_page) break;

                page++;
            }

            return all;
        },

        updateMapFeatures(features) {
            const source = this.map.getSource('locations');
            if (source) {
                source.setData({
                    type: 'FeatureCollection',
                    features,
                });
            }
        },
        meta(type) {
            return useTypeMeta(type)
        },
        getTranslated(item, lang = 'en') {
            if (!item) return '';

            const translations = item[lang] || item['en'];
            return translations;
        }
    },
    watch: {
        'filters': {
            handler: _.debounce(function (val) {
                this.searchLocations();
            }, 300),
            immediate: false,
            deep: true,
        },
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
        window.removeEventListener("resize", this.handleResize);

        window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.detectDarkMode);

    }
};
</script>